import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CURRENCY_SYMBOLS } from 'constants/index';

import Select from 'components/select';

const CURRENCIES = ['usd', 'eur', 'gbp', 'inr', 'jpy', 'cad', 'aud', 'chf', 'mxn', 'try', 'ils', 'rub', 'cny'];

const Selected = ({ id, text, symbolOnly }) => {
    if (symbolOnly) {
        return CURRENCY_SYMBOLS[id];
    }

    return text;
}

const CurrencySelector = ({ selected, darkLabel, labelDisabled, symbolOnly, onChange }) => {
    const { t } = useTranslation('common');

    const handleSelect = useCallback(({ id }) => {
        onChange?.(id);
    }, []);

    const options = useMemo(() => CURRENCIES.map(id => ({
        id,
        text: t(`currencies.${id}`) + ` (${CURRENCY_SYMBOLS[id]})`
    })), [t]);

    return (
        <Select
            label={ labelDisabled ? null : t('common:Currency') }
            darkLabel={darkLabel}
            options={options}
            selected={selected}
            selectedComponent={<Selected symbolOnly={symbolOnly} />}
            onSelect={handleSelect}
        />
    );
}

export default CurrencySelector;
